import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import { fetchCurrencySettings, detectGeoCurrency } from './store/slices/currencySlice';
import App from './App';
import './index.css';

import { setActiveCurrency } from './types/commissions.types';

// Keep the module-level `formatNaira`/`formatMoney` formatter in sync with
// the Redux currency slice. Must run BEFORE the first render so the very
// first paint already uses the correct display currency — `store.subscribe`
// listeners only fire on *future* dispatches, so we also call it once now.
const syncFormatter = () => {
  const { displayCurrency, rate } = store.getState().currency;
  setActiveCurrency({ currency: displayCurrency, ngnPerUsd: rate.ngnPerUsd });
};
syncFormatter();
store.subscribe(syncFormatter);

// Kick off async currency resolution: backend settings (admin default + FX
// rate) and IP geolocation (used to auto-pick NGN for NG visitors and USD
// for everyone else). User overrides from localStorage win in both thunks.
store.dispatch(fetchCurrencySettings());
store.dispatch(detectGeoCurrency());

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
